export const getRandomItemFromArray = <T extends unknown>(sourceArray: T[]): T => {
    const index = Math.floor(Math.random() * sourceArray.length);

    return sourceArray[index];
}